import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { user_role_display_name } from "../auth/constants";
import DocumentDrop from "./DocumentDropComponent";
import FullPageDocumentDropComponent from "./FullPageDocumentDropComponent";
import constants from "./constants";
import documentTypes from "./documentTypes";
import operations from "./ducks/operations";

const DocumentDropContainer = (props) => {
    const {
        viewOnly,
        entityKey,
        getDocumentRequirementsByParentEntityType,
        getDocuments,
        parentType,
        type,
        authRole,
        userProfile,
        getDocumentAttachmentPermissions,
        entityStatus,
    } = props;

    const [documentAttachmentPermissions, setPermissions] = useState(null);
    const [isDocumentRequirementsLoading, setIsDocumentRequirementsLoading] = useState(true);

    const loadDocumentPermissionsAndRequirements = async (payload) => {
        await getDocumentRequirementsByParentEntityType(payload, parentType);
        const documentAttachmentPermissions = await getDocumentAttachmentPermissions(payload);
        setPermissions(documentAttachmentPermissions);
        setIsDocumentRequirementsLoading(false);
    };

    useEffect(() => {
        if (!entityKey) return;

        const payload = {
            proxyUserRole: user_role_display_name[userProfile?.role],
            authenticatedRole: user_role_display_name[authRole?.role],
            parentEntityName: parentType,
            proxyUserPersonKey: userProfile?.personKey,
            authenticatedPersonKey: authRole?.personKey,
            parentEntityRecordKey: entityKey,
            parentEntityTypeStatus: entityStatus,
        };
        loadDocumentPermissionsAndRequirements(payload);
        getDocuments(entityKey, type);
    }, [entityKey, type, entityStatus, parentType]);

    const disableUploads = !documentAttachmentPermissions?.some((permission) => permission.canUpload === true);

    return (
        <div data-testid="documentDropContainer">
            {isDocumentRequirementsLoading && !viewOnly ? (
                <div className="circularProgressCentered">
                    <CircularProgress />
                </div>
            ) : (
                <React.Fragment>
                    <DocumentDrop
                        {...props}
                        disableUploads={disableUploads}
                        documentTypes={documentTypes[props.documentTypes]}
                        allDocumentTypes={documentTypes["all"]}
                        documentAttachmentPermissions={documentAttachmentPermissions}
                    />
                    <FullPageDocumentDropComponent {...props} disableUploads={disableUploads} />
                </React.Fragment>
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        role: state.authReducer.userProfile.role,
        snackbarOpen: state.authReducer.snackbarOpen,
        columnToSort: state.documentsReducer.documentColumnToSort,
        sortDirection: state.documentsReducer.documentSortDirection,
        used: state.documentsReducer.documentTypes,
        savedDocuments: state.documentsReducer.savedDocuments,
        missingRequiredDocuments: state.documentsReducer.missingRequiredDocuments,
        anchorEl: state.documentsReducer.anchorEl,
        docKey: state.documentsReducer.docKey,
        documentsUploading: state.documentsReducer.documentsUploading,
        elementsSaving: state.utilsReducer.elementsSaving,
        documentRequirements: state.documentsReducer.documentRequirements,
        requiredDocs: state.documentsReducer.requiredDocs,
        optionalDocs: state.documentsReducer.optionalDocs,
        documentTypesForParentEntity: state.documentsReducer.documentTypesForParentEntity,
        userProfile: state.authReducer.userProfile,
        authRole: state.authReducer.authenticatedUserProfile,
        deal: state.dealReducer.dealSummary,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideSnackbar: () => {
            dispatch(operations.hideSnackbar());
        },
        handleDocumentSort: (columnName) => {
            dispatch(operations.handleDocumentSort(columnName));
        },
        handleRejectedDocs: (rejected) => {
            dispatch(operations.handleRejectedDocs(rejected));
        },
        handleOpenDocumentMenu: (key, anchorEl) => {
            dispatch(operations.handleOpenDocumentMenu(key, anchorEl));
        },
        handleMenuClose: () => {
            dispatch(operations.handleMenuClose());
        },
        handleSort: (columnName) => {
            dispatch(operations.handleDocumentSort(columnName));
        },
        viewDocument: (url, key) => {
            dispatch(operations.viewDocument(url, key));
        },
        downloadDocument: (document) => {
            dispatch(operations.downloadDocument(document));
        },
        addDocuments: (key, type, documents, ownerType, parentType) => {
            dispatch(operations.addDocument(constants.urls.add_document(key, type), documents, ownerType, parentType));
        },
        removeDocument: (key) => {
            dispatch(operations.removeDocument(constants.urls.remove_document(key), key));
        },
        approveDocument: (key) => {
            dispatch(operations.approveDocument(constants.urls.approve_document(key), key));
        },
        getDocuments: (key, type) => {
            dispatch(operations.getDocuments(constants.urls.get_documents(key, type)));
        },
        copyDocUrl: (key) => {
            dispatch(operations.copyDocUrl(key));
        },
        toggleTerminationDoc: (attached) => {
            dispatch(operations.toggleTerminationDoc(attached));
        },
        updateDocumentFromAdminList: (key, parentEntityTypeKey, documentTypeKey, documentDao) => {
            dispatch(
                operations.updateDocumentFromAdminList(
                    constants.urls.update_document(key),
                    key,
                    parentEntityTypeKey,
                    documentTypeKey,
                    documentDao
                )
            );
        },
        getDocumentRequirementsByParentEntityType: (payload, parentType) => {
            dispatch(operations.getDocumentRequirementsByParentEntityType(payload, parentType));
        },
        setAdminDocumentTypeListAvailable: () => {
            dispatch(operations.setAdminDocumentTypeListAvailable());
        },
        resetRequiredMissingDocuments: () => {
            dispatch(operations.resetRequiredMissingDocuments());
        },
        getDocumentAttachmentPermissions: (payload) => {
            return dispatch(operations.getDocumentAttachmentPermissions(payload));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentDropContainer);
